import { ScreenNames } from '@hrms/common/routes/screens';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { ModuleConstants } from '@hrms/common/constant/modules';
import { generateImage } from '@hrms/common/utils/generateImage';

export const flexManagementBaseUrl = `/flex-management`;

const getFlexManagementModuleRoutes: ModuleRoutesComponentInterface = () => {
  return [
    {
      id: ModuleConstants.FLEX_MANAGEMENT,
      route: flexManagementBaseUrl,
      title: ScreenNames.FLEX_MANAGEMENT,
      icon: generateImage({
        noScale: true,
        name: 'users',
        alt: 'flex-management',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.FLEX_SLOT_MANAGEMENT,
          route: `${flexManagementBaseUrl}/slot-management`,
          title: ScreenNames.SLOT_MANAGEMENT,
          component: ComponentsMap.SLOT_MANAGEMENT,
        },
        {
          id: ModuleConstants.FLEX_SITE_MANAGEMENT,
          route: `${flexManagementBaseUrl}/site-management`,
          title: ScreenNames.FLEX_SITE_MANAGEMENT,
          component: ComponentsMap.FLEX_SITE_MANAGEMENT,
        },
        {
          id: ModuleConstants.FLEX_RATE_CARD_MANAGEMENT,
          route: `${flexManagementBaseUrl}/rate-card-management`,
          title: ScreenNames.RATE_CARD_MANAGEMENT,
          component: ComponentsMap.FLEX_RATE_CARD_MANAGEMENT,
        },
        {
          id: ModuleConstants.FLEX_SITE_MANAGEMENT,
          route: `${flexManagementBaseUrl}/site-management/:siteId`,
          title: ScreenNames.FLEX_SITE_MANAGEMENT_DETAILS,
          component: ComponentsMap.FLEX_SITE_MANAGEMENT_DETAILS,
          sidebarVisibility: false,
        },
        {
          id: ModuleConstants.FLEX_PAYOUT_MANAGEMENT,
          route: `${flexManagementBaseUrl}/payroll-management`,
          title: ScreenNames.FLEX_PAYOUT_MANAGEMENT,
          component: ComponentsMap.FLEX_PAYOUT_MANAGEMENT,
        },
      ],
    },
  ];
};

export { getFlexManagementModuleRoutes };
